import * as React from 'react';
import { reduxForm } from 'redux-form';
import { Trans, withTranslation } from 'react-i18next';

import FileCropInput from '@common/components/form/inputs/file-crop';
import * as Form from '@common/components/form';
import { Button } from '@common/components/button';
import Icon from '@common/components/icon';
import Alert from '@common/components/alert';

import { Api } from '@common/services/api';
import updateProfile from '../../../core/actions/update-profile';
import selectNetwork from '../../../network/actions/select-network';
import { selectOrganisation } from '../../../organisation/actions';

const { Row, Group, TextInput } = Form;

class RegistrationForm extends React.Component {
  static defaultProps = {
    formValues: {},
  };

  constructor() {
    super();

    this.state = {
      alert: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static props;

  async handleSubmit(values, dispatch) {
    const { organisationId, isAdmin, history } = this.props;
    if (!organisationId) {
      return console.error(`invalid organisationId: ${organisationId}`);
    }
    const [org] = await Promise.all([
      Api.get(`/v2/organisations/${organisationId}`),
      dispatch(updateProfile(values, true))
    ]);
    const isNewOrg = org?.data?.trial && !org.data.trial.setup_completed;

    let path = '/auth/organisations';
    if (isNewOrg) {
      path = `/auth/onboarding/${organisationId}?back=true`;
    } else if (isAdmin) {
      path = await dispatch(selectOrganisation(organisationId));
    } else {
      const url = `/v4/organisations/${organisationId}/networks`;
      const networks = await Api.get(url);
      const network = networks?.data?.[0];
      if (network) {
        path = await dispatch(selectNetwork(network.id));
      }
    }

    return history.push(path);
  }

  render() {
    const { alert } = this.state;
    const {
      loggedUser, formValues, change, handleSubmit, submitting, invalid, t
    } = this.props;

    const warning = alert ? <Alert type="warning">{alert}</Alert> : null;

    const fullName = `${formValues.first_name || ''} ${formValues.last_name || ''}`.trim();
    const filePreview = formValues.profile_img && URL.createObjectURL(formValues.profile_img);

    return (
      <>
        <form className="Form Registration__Form" onSubmit={handleSubmit(this.handleSubmit)}>
          {warning}
          <h1><Trans i18nKey="authentication:tell_about_yourself" /></h1>
          {loggedUser.first_name && (
            <h6><Trans i18nKey="authentication:check_info" /></h6>
          )}
          <h5><Trans i18nKey="authentication:label_profile_picture" /></h5>
          <Row>
            <Group>
              <FileCropInput onSubmit={(file) => change('profile_img', file)}>
                <div className="ProfilePictureInput">
                  {filePreview ? <img alt="profile img" src={filePreview} /> : <Icon type="person" />}
                  <Button type="inverted"><Trans i18nKey="authentication:registration_upload_picture" /></Button>
                </div>
              </FileCropInput>
            </Group>
          </Row>
          <h5><Trans i18nKey="authentication:profile_information" /></h5>
          <Row>
            <Group>
              <TextInput mask name="first_name" placeholder={t('authentication:registration_first_name')} />
            </Group>
          </Row>
          <Row>
            <Group>
              <TextInput mask name="last_name" placeholder={t('authentication:registration_last_name')} />
            </Group>
          </Row>
          <hr />
          <Row>
            <Group>
              <TextInput mask name="phone_num" placeholder={t('authentication:registration_phone_number')} />
            </Group>
          </Row>
          <Button
            type="primary"
            size="large"
            buttonType="submit"
            isLoading={submitting}
            disabled={invalid}
          >
            <Trans i18nKey="authentication:registration_confirm" />
          </Button>
        </form>
        <div className="Registration__Preview">
          <div className="Registration__Preview__Screen">
            <div className="Registration__Preview__Screen__Content">
              <div className="Registration__Preview__Screen__Image">
                {filePreview ? <img alt="profile img" src={filePreview} /> : <Icon type="person" />}
              </div>
              <h3>{fullName}</h3>
              <div className="Registration__Preview__Screen__Fields">
                <div className="Registration__Preview__Screen__Field fs-exclude">
                  <Icon type="person" />
                  <div>
                    <label><Trans i18nKey="authentication:profile_information_name" /></label>
                    {fullName || <small><Trans i18nKey="authentication:profile_information_empty" /></small>}
                  </div>
                </div>
                <div className="Registration__Preview__Screen__Field">
                  <Icon type="phone" />
                  <div>
                    <label><Trans i18nKey="authentication:profile_information_phone_num" /></label>
                    {formValues.phone_num || <small><Trans i18nKey="authentication:profile_information_empty" /></small>}
                  </div>
                </div>
                <div className="Registration__Preview__Screen__Field">
                  <Icon type="email" />
                  <div>
                    <label><Trans i18nKey="authentication:profile_information_email" /></label>
                    {loggedUser.email || <small><Trans i18nKey="authentication:profile_information_empty" /></small>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(reduxForm({
  form: 'registration',
  initialValues: {
    first_name: '',
    last_name: '',
    phone_num: '',
    profile_img: null,
  },
  validate: require('./validate').default,
})(RegistrationForm));
